export default __webpack_public_path__ + "static/aqua-3-c893ae3fa532cf2848c7b7d43919d8df.jpg";